export default "__VITE_ASSET__CrdnJIDk__"